module.exports = __webpack_public_path__ + "static/media/eha-logo.9899121f.png";